<template>
	<div
		class="multi-format-graphic-selector"
		:aria-label="$I18n.trans('event.multiformat_editor.labels.branding')"
	>
		<button
			v-for="option in options"
			:key="option.value ?? 'none'"
			type="button"
			class="multi-format-graphic-selector__option"
			:class="{ 'is-active': option.value === value }"
			:aria-pressed="option.value === value ? 'true' : 'false'"
			:title="option.label"
			@click="$emit('change', option.value)"
		>
			<span class="multi-format-graphic-selector__label">
				{{ option.label }}
			</span>
			<span
				v-if="option.aspectRatio"
				class="multi-format-graphic-selector__aspect-ratio"
			>
				{{ option.aspectRatio }}
			</span>
		</button>
	</div>
</template>

<script>
export default {
	name:  'MultiFormatGraphicSelector',
	props: {
		value: {
			type:    [String, Number],
			default: null,
		},
		options: {
			type:    Array,
			default: () => [],
		},
	},
};
</script>

<style lang="scss" scoped>
@import '@shared/sass/shared-variables';

.multi-format-graphic-selector {
	display: flex;
	flex-direction: column;
	gap: $sp3;
	width: 100%;
}

.multi-format-graphic-selector__option {
	display: flex;
	align-items: center;
	justify-content: space-between;
	gap: $sp3;
	width: 100%;
	min-height: 44px;
	padding: $sp3 $sp4;
	border: 1px solid var(--color-grey-800);
	border-radius: var(--t-border-radius-card--lg);
	overflow: hidden;
	color: var(--color-grey-050);
	cursor: pointer;
	transition: border-color $trans-time-fast, background-color $trans-time-fast, color $trans-time-fast;

	body.-t-light & { // stylelint-disable-line
		border-color: var(--color-grey-900);
	}

	&:hover,
	&:focus {
		border-color: var(--color-grey-600);

		body.-t-light & { // stylelint-disable-line
			border-color: var(--color-grey-800);
		}
	}

	&.is-active {
		border-color: var(--color-hype-yellow);
		background-color: var(--color-grey-800);

		body.-t-light & { // stylelint-disable-line
			border-color: var(--color-hype-yellow);
			background-color: var(--color-grey-900);
		}
	}
}

.multi-format-graphic-selector__label {
	@include font-size(fs-100);
	display: block;
	min-width: 0;
	overflow: hidden;
	text-overflow: ellipsis;
	white-space: nowrap;
}

.multi-format-graphic-selector__aspect-ratio {
	@include font-size(fs-60);
	flex-shrink: 0;
	color: var(--color-grey-400);
}

</style>
